import {
  FormHelperText as MUIFormHelperText,
  FormHelperTextProps as MUIFormHelperTextProps,
} from '@mui/material';
import { mergeSX } from '../../services/helpers';
import { TYPOGRAPHY_CAPTION } from '../Typography';
import { AR1 } from '../../theme';

export interface IFormHelperTextProps extends MUIFormHelperTextProps {}

const buildSX = () => ({
  '&.MuiFormHelperText-root': {
    ...TYPOGRAPHY_CAPTION,
    margin: '0 0 0 16px',
    '&.Mui-error': {
      color: AR1,
    },
  },
});

const FormHelperText = (props: IFormHelperTextProps) => {
  const { children, sx, ...restProps } = props;
  return (
    <MUIFormHelperText sx={mergeSX(buildSX(), sx)} {...restProps}>{children}</MUIFormHelperText>
  );
};

export default FormHelperText;
